import { fetchPopularHousingSsr } from '@/features/pages/home/api';
import { type Locale } from '@/config/i18n/locales';
import { Featured } from './Featured';
import { StructuredData } from '@/components/common/StructuredData/StructuredData';
import { generateFeaturedListingsSchema } from '@/common';
import { inheritSsrContext } from '@/lib/ssrRequestContext';

type FeaturedAsyncProps = {
  locale: Locale;
  pageId: string;
};

export const FeaturedAsync = async ({ locale, pageId }: FeaturedAsyncProps) =>
  inheritSsrContext(pageId, 'home:ssr', async () => {
    const data = await fetchPopularHousingSsr(locale);
    const schemas = data?.length ? generateFeaturedListingsSchema(data, locale) : null;
    return (
      <>
        {schemas?.length ? <StructuredData data={schemas} /> : null}
        <Featured data={data} />
      </>
    );
  });
